// Sends every tracked event to our own backend event-ingestion API (same
// contract as eci-subscription's trackEvent.js), so events from inside the
// loan-journey iframe land in the same events store instead of requiring a
// cross-origin postMessage bridge back to the parent subscription app.
import { loanJourneyEventDescriptions } from './eventDescriptions/loanJourney';
import { getStorage } from './apiUtils';

const EVENT_DESCRIPTIONS = {
  ...loanJourneyEventDescriptions,
};

const getAnchor = () =>
  (window.location.pathname.split('/')[1] || '').toUpperCase() || null;

const getPageContext = () => ({
  page_path: window.location.pathname,
  page_title: document.title || null,
  referrer: document.referrer || null,
});

const getDeviceContext = () => {
  const ua = navigator.userAgent || '';
  const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(ua);
  return {
    device_type: isMobile ? 'mobile' : 'desktop',
  };
};

export const trackEvent = (name, properties = {}) => {
  if (!name) return;

  const EVENTS_BASE_URL =
    process.env.REACT_APP_EVENTS_BASE_URL || 'http://localhost:8001';

  const body = {
    event_name: name,
    event_description: EVENT_DESCRIPTIONS[name] || '',
    anchor: getAnchor(),
    platform: 'web',
    data: {
      event_properties: properties,
      page: getPageContext(),
      device: getDeviceContext(),
    },
    application_id: getStorage('application_id') || null,
  };

  if (process.env.NODE_ENV === 'development') {
    console.info('[analytics]', name, body);
  }

  fetch(`${EVENTS_BASE_URL}/api/v1/events/`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  }).catch((error) => {
    console.error('[analytics] failed to send event', name, error);
  });
};

export default trackEvent;
